import axios from "axios";
import { setupInterceptors } from "./interceptors";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/v1`,
  // timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

setupInterceptors(axiosInstance);

export default axiosInstance;
